import React, { FC, ReactNode } from "react";
import Formula from "../Formula/Formula";

interface ValueListDisplayProps {
    title?: ReactNode;
    values: (string | number)[];
    bgColor?: string;
    textColor?: string;
}

const ValueListDisplay: FC<ValueListDisplayProps> = ({ values, bgColor = "bg-blue-100", textColor = "text-blue-800", title }) => {
    if (!values.length) return null;

    return (
        <div className="my-3 text-center">
            {title && <p className="font-bold">{title}</p>}
            <div className="flex flex-wrap justify-center gap-2 mt-2">
                {values.map((val, index) => (
                    <div
                        key={index}
                        className={`${bgColor} ${textColor} flex items-center px-2 py-1 min-h-[40px] rounded-xl shadow-md font-semibold`}
                    >
                        <Formula formula={`${val}`} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ValueListDisplay;
